import { DispatchSelection } from 'src/components/dispatch/detailPanel/DispatchDetailPanel';
import { scopeGroupsToVehicle } from 'src/components/dispatch/vehicleRowScope';
import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/**
 * 「他車両へ配車」の移動元の行（= 選択中のカードが実際に載っている行）を解決する。
 * 積地カードも対象 (logposeTech/log_web_issues#320)。
 *
 * Why 1 本にまとめる: 同じ探索が /map・カード配車・アクション層の 3 箇所にあり、
 * #320 では「降地カードだけ探す」条件がそれぞれに書かれていたため、積地から
 * 移そうとすると移動元が解決できず候補が空になっていた。条件を 1 箇所に閉じる。
 *
 * Why not rowId 以外も返す: 呼び出し側が使うのは rowId だけ（移動先は shiftId で
 * 引き直す。buildMoveTargets の Why not 参照）。
 *
 * Why 勤務で絞ってから探す: 積地カードの id は勤務をまたいで衝突するため、id だけで
 * 全勤務を探すと別勤務の行を移動元にしてしまい、runTransfer へ誤った
 * transfer_from_shift_id が渡る（scopeGroupsToVehicle の Why 参照）。
 */
export function resolveMoveSourceRowId(
  selection: DispatchSelection,
  rowGroups: readonly VehicleRowGroup[],
): string | null {
  if (!selection || selection.source !== 'vehicle') return null;
  const cardId = selection.card.id;
  for (const group of scopeGroupsToVehicle(selection.vehicle, rowGroups)) {
    const row = group.rows.find((r) => r.cards.some((c) => c.id === cardId));
    if (row) return row.rowId;
  }
  return null;
}
